import axios from 'axios';
import { format } from 'date-fns';

function hasBearerToken() {
  return !!localStorage.getItem('produce-token');
}

export function getBearerToken() {
  if (localStorage.getItem('produce-token')) {
    const token = JSON.parse(localStorage.getItem('produce-token'));
    return token.access_token;
  }
  throw Error('Not authenticated');
}

function toDate(date) {
  if (!date) {
    return null;
  }
  return format(date, 'yyyy-MM-dd');
}

export async function getSsoUser() {
  if (!hasBearerToken()) {
    return null;
  }
  return axios
    .post(
      window.config('auth.user'),
      {
        client_id: window.config('auth.clientId')
      },
      {
        headers: {
          Authorization: `Bearer ${getBearerToken()}`
        }
      }
    )
    .then(data => {
      return { ...data.data.data, full_name: data.data.data.name };
    });
}

export async function getUser() {
  return getSsoUser();
}
